import { createSlice } from "@reduxjs/toolkit";
import {
  getProjects,
  addNewProject,
  updateProject,
  deleteProject,
  getProjectById,
  getProjectPhasesById,
} from "./thunk";

export const initialState = {
  projects: [],
  projectPhases: [],
  error: null,
  selectedProject:null,
  isProjectSuccess: false,
  isProjectCreated: false,
};

const projectsSlice = createSlice({
  name: "ProjectsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch projects
    builder.addCase(getProjects.fulfilled, (state, action) => {
      state.projects = action.payload; // Assuming `action.payload` contains project data
      state.isProjectSuccess = true;
      state.error = null;
    });

    builder.addCase(getProjects.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch projects";
      state.isProjectSuccess = false;
    });
    // Fetch a single project by ID
    builder.addCase(getProjectById.fulfilled, (state, action) => {
      state.selectedProject = action.payload; // Set the selected project
      state.error = null;
    });

    builder.addCase(getProjectById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch project by ID";
      state.selectedProject = null; // Clear the selected project on failure
    });

    builder.addCase(getProjectPhasesById.fulfilled, (state, action) => {
      state.projectPhaes = action.payload; // Set the selected project
      state.error = null;
    });

    builder.addCase(getProjectPhasesById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch project by ID";
      // state.selectedProject = null; // Clear the selected project on failure
    });

    // Add new project
    builder.addCase(addNewProject.fulfilled, (state, action) => {
      state.projects.push(action.payload); // Add the new project to the list
      state.isProjectCreated = true;
      state.error = null;
    });

    builder.addCase(addNewProject.rejected, (state, action) => {
      state.error = action.payload || "Failed to add project";
      state.isProjectCreated = false;
    });

    // Update project
    builder.addCase(updateProject.fulfilled, (state, action) => {
      state.projects = state.projects.map((project) =>
        project.id === action.payload.id ? { ...project, ...action.payload } : project
      );
      state.error = null;
    });


    builder.addCase(updateProject.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to update project";
    });

    // Delete project
    builder.addCase(deleteProject.fulfilled, (state, action) => {
      state.projects = state.projects.filter(
        (project) => project.id !== action.payload.projectId
      );
      state.error = null;
    });

    builder.addCase(deleteProject.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete project";
    });
  },
});

export default projectsSlice.reducer;
